// chartTypes.ts
// imports and stores all the media for Chart icons
import multiBarIcon from '../../../assets/new_bar.svg';
import horizontalBar from '../../../assets/new_horizondalBar.svg';
import stackedBarIcon from '../../../assets/new_stackedBar.svg';
import horizontalStackedBar from '../../../assets/new_horizondalStackedBar.svg';
import lineChartIcon from '../../../assets/new_line.svg';
import areaChartIcon from '../../../assets/new_area.svg';
import pieChartIcon from '../../../assets/new_pie.svg';
import donutChartIcon from '../../../assets/new_doughnut.svg';
import scatterPlotIcon from '../../../assets/new_scatterPlot.svg';
import funnelChartIcon from '../../../assets/new_Funnel.svg';
import gaugeChartIcon from '../../../assets/new_gauge.svg';
import heatMapIcon from '../../../assets/new_heatMap.svg';
import CrossTabIcon from '../../../assets/new_crossTab.svg';
import roseChartIcon from '../../../assets/new_rose.svg';
import simpleCard from '../../../assets/Simple_Card_icon.svg';
import filledMapIcon from '../../../assets/map_filled.svg';
import bubbleMapIcon from '../../../assets/map_dot.svg';
import stackedAreaChartIcon from '../../../assets/new_areaStacked.svg';
import calendarChartIcon from '../../../assets/new_calendar.svg';
import boxPlotIcon from '../../../assets/new_boxPlot.svg';
import TreeMapIcon from '../../../assets/new_treeMap.svg';
import TableIcon from '../../../assets/table.svg';
import TextEditorIcon from '../../../assets/Rich_Text_icon.svg';
import Sankey from '../../../assets/new_sankey.svg';
import waterfallChartIcon from '../../../assets/waterfallChart.svg';
import wordCloudIcon from '../../../assets/word_cloud.svg';

export const chartTypes = [
  { name: 'crossTab', icon: CrossTabIcon, value: ' Cross Tab' },
  { name: 'pie', icon: pieChartIcon, value: ' Pie Chart' },
  { name: 'donut', icon: donutChartIcon, value: ' Donut Chart' },
  { name: 'rose', icon: roseChartIcon, value: 'Rose Chart' },
  { name: 'multibar', icon: multiBarIcon, value: 'Multi Bar' },
  { name: 'horizontalBar', icon: horizontalBar, value: 'Horizontal Bar' },
  { name: 'stackedBar', icon: stackedBarIcon, value: 'Stacked Bar' },
  {
    name: 'horizontalStacked',
    icon: horizontalStackedBar,
    value: 'Horizontal Stacked Bar',
  },
  { name: 'line', icon: lineChartIcon, value: 'Line Chart' },
  { name: 'area', icon: areaChartIcon, value: 'Area Chart' },
  {
    name: 'stackedArea',
    icon: stackedAreaChartIcon,
    value: 'Stacked Area Chart',
  },
  { name: 'scatterPlot', icon: scatterPlotIcon, value: ' Scatter Plot' },
  { name: 'gauge', icon: gaugeChartIcon, value: 'Gauge Chart' },
  { name: 'funnel', icon: funnelChartIcon, value: 'Funnel Chart' },
  { name: 'heatmap', icon: heatMapIcon, value: 'Heat Map' },
  { name: 'treeMap', icon: TreeMapIcon, value: 'Tree Map' },
  { name: 'filledMap', icon: filledMapIcon, value: 'Filled Map' },
  { name: 'bubbleMap', icon: bubbleMapIcon, value: 'Bubble Map' },
  { name: 'calendar', icon: calendarChartIcon, value: 'Calendar Chart' },
  { name: 'boxPlot', icon: boxPlotIcon, value: 'Box Plot Chart' },
  { name: 'sankey', icon: Sankey, value: 'Sankey Chart' },
  { name: 'richText', icon: TextEditorIcon, value: 'Rich Text' },
  { name: 'simplecard', icon: simpleCard, value: 'Simple Card' },
  { name: 'table', icon: TableIcon, value: 'Table' },
  { name: 'waterfall', icon: waterfallChartIcon, value: 'Waterfall Chart' },
  { name: 'wordCloud', icon: wordCloudIcon, value: 'WordCloud Chart' },
];
